import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  PLAN_STATUS_KEY,
  CONNECTION_STATUS_COLORS,
  SUSPENDED_CONTRACT_STATUS_COLOR,
  FIREBASE_EVENTS,
  DEFAULT_CONNECTION_STATUS_COLOR,
  DRAWER_KEY,
} from 'app-constants'
import { InfoCard, Tag } from 'components'
import { useFirebaseEvent } from 'hooks'
import { fetchConnectionStatus } from 'slices/contract'
import { setDrawer, setStage } from 'slices/drawer'
import { STATICS } from 'statics'
import './style.scss'

export function SubscriptionCard() {
  const selectedContract = useSelector(state => {
    const { address, id, situation, contractStatus } = state.contract.selected
    const { zipCode, type, street, number, complement, neighborhood, city, uf } = address

    return {
      zipCode,
      type: type?.toLowerCase(),
      street: street?.toLowerCase(),
      number,
      complement: complement?.toLowerCase(),
      neighborhood: neighborhood?.toLowerCase(),
      city: city?.toLowerCase(),
      uf,
      idContract: id,
      situation,
      contractStatus,
    }
  })
  const { type, street, number, city, uf, idContract, situation, contractStatus } = selectedContract
  const { connectionStatus, connectionStatusDescription } = useSelector(state => state.contract)
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState()

  useEffect(() => {
    if (!connectionStatus) {
      setIsLoading(true)
      dispatch(fetchConnectionStatus(idContract))
        .unwrap()
        .finally(() => setIsLoading(false))
    }
  }, [idContract, dispatch, connectionStatus])

  function handleOpenPlanDetails() {
    dispatch(setDrawer(DRAWER_KEY.PLAN))
  }

  function handleOpenDueDate() {
    dispatch(setDrawer(DRAWER_KEY.DUE_DATE))

    if (contractStatus !== PLAN_STATUS_KEY.ST_CONT_HABILITADO) {
      sendEvent(FIREBASE_EVENTS.CLICK_CHANGE_DUE_DATE_INELIGIBLE)
      dispatch(setStage('disabled'))
    } else {
      sendEvent(FIREBASE_EVENTS.CLICK_CHANGE_DUE_DATE)
    }
  }

  function getConnectionColor() {
    const isSuspendedByDebit = contractStatus === PLAN_STATUS_KEY.ST_CONT_SUSP_DEBITO

    if (isSuspendedByDebit) return SUSPENDED_CONTRACT_STATUS_COLOR

    return CONNECTION_STATUS_COLORS[connectionStatus]
  }

  // TODO silva.william 01/06/2026: Adicionar novamente o status da conexão ou remover o código do card.
  // eslint-disable-next-line no-unused-vars
  function renderConnectionStatus() {
    if (isLoading) return <div className='connection-status loading' />
    if (!connectionStatus) return null

    const connectionColor = getConnectionColor()

    return (
      <div className='connection-status'>
        <div
          className='round'
          style={{ backgroundColor: connectionColor || DEFAULT_CONNECTION_STATUS_COLOR }}
        />
        <span className='status'>{connectionStatusDescription}</span>
      </div>
    )
  }

  return (
    <InfoCard
      title='Meu plano'
      actions={[
        {
          icon: <STATICS.CHANGE_DUE_DATE />,
          label: 'Alterar vencimento da fatura',
          onClick: handleOpenDueDate,
        },
        {
          icon: <STATICS.SEE_PLANS />,
          label: 'Ver meu plano',
          onClick: handleOpenPlanDetails,
        },
      ]}
    >
      <div className='customer-plan-info'>
        <div className='contract-info'>
          <p>
            Contrato: <strong>{idContract}</strong>
          </p>
          {situation && <Tag text={situation} color='primary' />}
        </div>
        <div className='address-info'>
          <p>
            {type} {street}, {number} - {city}, {uf}
          </p>
        </div>
      </div>
    </InfoCard>
  )
}
